import request from '../config/network/requestUcenterApiService'
import request2 from '../config/network/requestMockApiService'
// 账号密码登录
export function login ({ username, password, ...params }) {
  return request({
    url: 'oauth/token',
    method: 'post',
    data: {
      username,
      password,
      grant_type: 'password',
      client_id: '2',
      client_secret: 'bFBAD2a1LK3XbqWmUvLg921MlM0URoRQFB9dkRLr',
      scope: '*',
      ...params
    }
  })
}

/**
 * 获取用户信息
 * */
export function getUserInfo () {
  return request({
    url: 'api/users',
    method: 'get'
  })
}

/**
 * 获取用户信息详情
 * */
export function getUserInfoDetail () {
  return request2({
    url: 'api/users',
    method: 'get'
  })
}

// 获取校区配置
export function getLogo (clientsId) {
  return request({
    url: `api/clients-configs/detail/${clientsId}`,
    method: 'GET'
  })
}

// 是否为试用会员，默认为否
export function getVipInfo (clientsId) {
  return request({
    url: `api/clients/${clientsId}?clients_id=${clientsId}`,
    method: 'GET'
  })
}